<template>
  <section :id class="container">
    <div class="quote max-w-screen-tablet">
      <blockquote v-blokkli-editable:field_text class="blockquote">
        {{ quote }}
      </blockquote>
      <div class="mt-4 flex items-center gap-4">
        <div
          class="aspect-square size-16 shrink-0 overflow-hidden rounded-full tablet:size-20"
        >
          <MediaImage
            v-if="image"
            v-blokkli-droppable:field_image
            v-bind="image"
            responsive-style="grid_small"
          />
        </div>
        <div class="text-prose text-scheme-invert">
          <div v-blokkli-editable:field_title class="font-bold">
            {{ name }}
          </div>
          <div v-blokkli-editable:field_text_additional>{{ description }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphQuoteFragment } from '#graphql-operations'

defineProps<{
  name?: string
  description?: string
  quote?: string
  image?: ParagraphQuoteFragment['image']
}>()

const { index, siblings } = defineBlokkli({
  bundle: 'quote',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>
